export default class FilterChangeDto {
  component
  value
  isDefaultValue
  constructor (component, value, isDefaultValue = false) {
    this.component = component
    this.value = value
    this.isDefaultValue = isDefaultValue
  }
}
